module.exports = __webpack_public_path__ + "img/3.481c3ad3.jpg";